import { Color } from './../../../models/color.models';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingComponent implements OnInit {
  @Input() color: Color = '#fff'
  @Input() size = '50px'

  constructor() { }

  ngOnInit(): void {
  }
}
